/**
 * Global JS
 */

// CSS
import styles from '../scss/index.scss';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/wl-share';
import './lib/wl-sticky';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/back-to-top';
import cart from './site/cart';
import './site/mobile-nav';
import './site/print-part-list';
import './site/search-autosuggest';
import './site/side-nav';
import './site/validate-email';
import './site/user_country';

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false, // Prevent page from jumping back to top
    },
  },
});

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  infinite: true,
  speed: 500,
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

// Init Sync
const carouselSync = carousels('[data-carousel="sync"]', {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '[data-carousel="slider-nav"]',
});
const carouselSyncNav = carousels('[data-carousel="slider-nav"]', {
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '[data-carousel="sync"]',
  dots: false,
  centerMode: false,
  arrrows: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
});

// load images
$('.blur-load img').ready(function() {
  $('.blur-load img').css({
    filter: 'blur(0px)',
    opacity: '1',
    visibility: 'visible',
  });
  $('.product__slider-title').css({
    opacity: '1',
    visibility: 'visible',
  });
  $('.product__slider-thumbnail span').css({
    filter: 'blur(0px)',
    opacity: '1',
    visibility: 'visible',
  });
});

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

$('[data-toggle-group-show-all]').click(function() {
  if (this.classList.contains('btn--expand')) {
    $('[data-toggle-group="quick-order-accordion"]').trigger(
      'toggle:groupShowAll'
    );
    this.innerHTML = 'Collapse All';
    this.classList.remove('btn--expand');
  } else {
    $('[data-toggle-group="quick-order-accordion"]').trigger(
      'toggle:groupHideAll'
    );
    this.innerHTML = 'Expand All';
    this.classList.add('btn--expand');
    console.log('Collapse');
  }
});

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');

// Init Cart
cart('[data-cart]');

// Init Sticky
$('#sticky').sticky();
